import { useExperimentGroup } from 'shared/src/context/UserContext/useExperimentGroup';

/**
 * 무물라이브 노출 대상 여부 (EXP1867 B군).
 */
export const useIsMumulLiveExposed = () =>
  useExperimentGroup({ sno: 'EXP1867', targetGroups: ['B'] });
